import * as React from 'react';
import styled from 'styled-components';

import { useSelector } from 'react-redux';
import { PERMIT_MENU_ACTIVE_TAB } from '../constants/permitMenu';

import PermitActionsTable from './PermitActionsTable';
import NotesPage from '../pages/Permits/NotesPage';
import TicketsPage from '../pages/Permits/TicketsPage';
import ConditionsPage from '../pages/Permits/ConditionsPage';
import FeesPage from '../pages/Permits/FeesPage';
import InspectionsPage from '../pages/Permits/InspectionsPage';
import DocumentsPage from '../pages/Permits/DocumentsPage';
import InvoiceTool from '../Components/InvoiceTool/InvoiceTool';
import { InvoiceWrapper } from '../forms/FeesSendForm';
import { Loader } from '../atoms';
import { RootState } from '../redux/root';
import ViewInvoiceModal from '../Components/InvoiceTool/ViewInvoiceModal';
import CompletedToggle from './CompletedToggle';

const PermitContentBlock = ({
  projectId,
  permit,
  permitStatus,
  activeTab,
  activityType,
  isAddNote,
  setAddNote,
  isAddTicket,
  setAddTicket,
  setAddInspection,
  isAddInspection,
  isAddFees,
  setAddFees,
  activityCreated,
  setActivityCreated,
  isAddCondition,
  setAddCondition,
  setFeeSelected,
  isSendingSelectedFees,
  setIsSendingSelectedFees,
  selectedBuilding,
  selectedWork,
  isAddDocument,
  setAddDocument,
  isDownloadAllDocs,
  setDocsAvailable,
  setDownloadAllDocs,
  setDocsWaitingOnClient,
  setDisableSend,
  isSendDocs,
  setSendDocs,
  cameFromSearch,
  handleDocumentData,
  isLocked,
  setDisableReviewCommentBtn,
  showReviewCommentLtr,
  setShowReviewCommentLtr,
}: Props) => {
  const isGeneratingInvoice = useSelector((s:RootState) => s.fees.isGeneratingInvoice);
  if (activeTab === PERMIT_MENU_ACTIVE_TAB.ACTIVITIES) {
    return (
      <Container>
        <ToggeleWrapper>
          <ToggleTitle>Permit Activities</ToggleTitle>
          <CompletedToggle />
        </ToggeleWrapper>
        <PermitActionsTable
          projectId={projectId}
          permit={permit}
          activityType={activityType}
          activityCreated={activityCreated}
          setActivityCreated={setActivityCreated}
          cameFromSearch={cameFromSearch}
          setDisableReviewCommentBtn={setDisableReviewCommentBtn}
          showReviewCommentLtr={showReviewCommentLtr}
          setShowReviewCommentLtr={setShowReviewCommentLtr}
        />
      </Container>
    );
  }

  if (activeTab === PERMIT_MENU_ACTIVE_TAB.INSPECTIONS) {
    return (
      <Container>
        <ContentTitle>Permit Inspections</ContentTitle>
        <InspectionsPage
          projectId={projectId}
          permit={permit}
          permitStatus={permitStatus}
          isAddInspection={isAddInspection}
          setAddInspection={setAddInspection}
          cameFromSearch={cameFromSearch}
        />
      </Container>
    );
  }
  if (activeTab === PERMIT_MENU_ACTIVE_TAB.FEES) {
    return (
      <Container>
        <div style={{ position: 'relative' }}><ContentTitle>Permit Fees</ContentTitle>
          {isGeneratingInvoice && <LoaderWrapper><Loader /></LoaderWrapper>}
        </div>
        <ViewInvoiceModal />
        <FeesPage
          permit={permit}
          isAddFees={isAddFees}
          setAddFees={setAddFees}
          setFeeSelected={setFeeSelected}
          isSendingSelectedFees={isSendingSelectedFees}
          setIsSendingSelectedFees={
            setIsSendingSelectedFees
          }
          cameFromSearch={cameFromSearch}
        />
      </Container>
    );
  }

  if (activeTab === PERMIT_MENU_ACTIVE_TAB.NOTES) {
    return (
      <Container>
        <ContentTitle>Permit Notes</ContentTitle>
        <NotesPage
          permit={permit}
          isAddNote={isAddNote}
          setAddNote={setAddNote}
        />
      </Container>
    );
  }

  if (activeTab === PERMIT_MENU_ACTIVE_TAB.TICKETS) {
    return (
      <Container>
        <ContentTitle>Permit Tickets</ContentTitle>
        <TicketsPage isAddTicket={isAddTicket} setAddTicket={setAddTicket} permit={permit} projectId={projectId} />
      </Container>
    );
  }

  if (activeTab === PERMIT_MENU_ACTIVE_TAB.DOCUMENTS) {
    return (
      <Container>
        <ContentTitle>Permit Documents</ContentTitle>
        <DocumentsPage
          permit={permit}
          work={selectedWork?.id}
          building={selectedBuilding?.id}
          isAddDocument={isAddDocument}
          setAddDocument={setAddDocument}
          isDownloadAllDocs={isDownloadAllDocs}
          setDocsAvailable={setDocsAvailable}
          setDownloadAllDocs={setDownloadAllDocs}
          setDocsWaitingOnClient={setDocsWaitingOnClient}
          setDisableSend={setDisableSend}
          isSendDocs={isSendDocs}
          setSendDocs={setSendDocs}
          cameFromSearch={cameFromSearch}
          handleDocumentData={handleDocumentData}
          isLocked={isLocked}
        />
      </Container>
    );
  }

  if (activeTab === PERMIT_MENU_ACTIVE_TAB.CONDITIONS) {
    return (
      <Container>
        <ContentTitle>Permit Conditions</ContentTitle>
        <ConditionsPage
          permit={permit}
          setAddCondition={setAddCondition}
          isAddCondition={isAddCondition}
          cameFromSearch={cameFromSearch}
        />
      </Container>
    );
  }
  return null;
};

interface Props {
  permit: number;
  activeTab: PERMIT_MENU_ACTIVE_TAB;
  activityType: number;
  isAddNote: boolean;
  isAddTicket: boolean;
  isAddFees: boolean;
  isSendDocs: boolean;
  isAddInspection: boolean;
  setAddNote: (data: boolean) => void;
  setAddTicket: (data: boolean) => void;
  setAddFees: (data: boolean) => void;
  setAddInspection: (data: boolean) => void;
  setActivityCreated: (data: boolean) => void;
  setAddCondition: (data: boolean) => void;
  setFeeSelected: (data: boolean) => void;
  isAddDocument: boolean;
  setAddDocument: (data: boolean) => void;
  setIsSendingSelectedFees: (data: boolean) => void;
  activityCreated: boolean;
  isAddCondition: boolean;
  isSendingSelectedFees: boolean;
  selectedWork: any;
  selectedBuilding: any;
  isLocked: boolean;
  isDownloadAllDocs: boolean;
  setDocsAvailable: (data: boolean) => void;
  setDownloadAllDocs: (data: boolean) => void;
  setDocsWaitingOnClient: (data: boolean) => void;
  setSendDocs: (data: boolean) => void;
  handleDocumentData:(data:any)=>void;
}

const Container = styled.div`
  margin: 24px 0 50px 0;
  width: 100%;
  box-sizing: border-box;
  padding: 0 16px;

  @media (max-width: 840px) {
    margin: 16px 0 32px 0;
    padding: 0 12px;
  }

  @media (max-width: 540px) {
    margin: 10px 0 24px 0;
    padding: 0 10px;
  }
`;

const ContentTitle = styled.h2`
  text-align: center;
  margin-bottom: 33px;
`;

const LoaderWrapper = styled.div`
  position: absolute;
  right: calc(50% - 124px);
  top: -2px;
`;

const ToggleTitle = styled.h2`
  text-align: center;
  margin: 0;
`;

const ToggeleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-3);
  margin-bottom: 33px;
`;
export default PermitContentBlock;
